import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout-footer full-content" }
const _hoisted_2 = { class: "layout-link center-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"layout-link-piece\"><div class=\"link-piece-title\">友情链接</div><div class=\"link-piece-list\"><a href=\"http://fao.hangzhou.gov.cn\" target=\"_blank\" class=\"link-piece-item\">杭州市外事办公室</a><a href=\"https://www.zjzwfw.gov.cn/zjservice-fe/#/home?siteCode=330000000000\" target=\"_blank\" class=\"link-piece-item\">浙江政务服务网</a><a href=\"https://www.idcpc.org.cn\" class=\"link-piece-item\" target=\"_blank\">中共中央对外联络部</a><a href=\"https://www.cpaffc.org.cn\" class=\"link-piece-item\" target=\"_blank\">中国人民对外友好协会</a></div></div><div class=\"layout-link-piece\"><div class=\"link-piece-title\">联系方式</div><div class=\"link-piece-list\"><a href=\"tel:0571-88385447\" class=\"link-piece-item\">0571-88385447（会议服务）</a><a href=\"tel:0571-88380340\" class=\"link-piece-item\">0571-88380340（出入境服务）</a><a href=\"tel:0571-88382563\" class=\"link-piece-item\">0571-88382563（翻译服务）</a><a href=\"tel:0571-87008253\" class=\"link-piece-item\">0571-87008253（签证服务）</a></div></div><div class=\"layout-link-piece\"><div class=\"link-box\"><div class=\"link-piece-title\">地址：</div><div class=\"link-box-text\"> 杭州市拱墅区王马东路92号武林之星博览中心4号楼3F </div></div><div class=\"link-box\"><div class=\"link-piece-title\">邮箱：</div><div class=\"link-box-text\"><a href=\"mailto:guojiaozhongxin1@163.com\" class=\"link-box-a\"> guojiaozhongxin1@163.com </a></div></div><div class=\"link-box\"><div class=\"link-piece-title\">电话：</div><div class=\"link-box-text\"><a href=\"tel:0571-88382653\" class=\"link-box-a\">0571-88382653</a> / <a href=\"tel:0571-88386328\" class=\"link-box-a\">0571-88386328</a></div></div></div>", 3)
const _hoisted_6 = { class: "layout-link-piece link-route" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"layout-concat\"><div class=\"layout-concat-box center-content\"><div class=\"layout-concat-logo\"></div><div class=\"layout-record flex-grow flex-box justify-center\" style=\"gap:1em;\"> 杭州国际会议外事通 <a href=\"https://beian.miit.gov.cn\">浙ICP备2022008259号-2</a></div></div></div>", 1)


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutFooter',
  props: ["navs"],
  setup(__props) {


const shareList = [
  {
    icon: require("@/assets/image/wechat.png"),
    link: "",
  },
  {
    icon: require("@/assets/image/qq.png"),
    link: "",
  },
  {
    icon: require("@/assets/image/sina.png"),
    link: "",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navs, (n, i) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            to: { name: n.routeName },
            class: "layout-link-route",
            key: i
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(n.title), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ]),
    _hoisted_7
  ]))
}
}

})